import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="carousel"
export default class extends Controller {
  static targets = ["track", "indicator"];

  connect() {
    // Ensure the state is correct on load
    if (this.hasTrackTarget && this.hasIndicatorTarget) {
      this.update();
    }
  }

  // Called automatically when the user swipes the track
  update() {
    if (!this.hasTrackTarget || !this.hasIndicatorTarget) return;

    const track = this.trackTarget;
    // Calculate which image is currently in the center of the viewport
    const index = Math.round(track.scrollLeft / track.clientWidth);

    this.indicatorTargets.forEach((indicator, i) => {
      if (i === index) {
        // Active dot stretches into a pill and becomes fully opaque
        indicator.classList.remove("w-1.5", "bg-white/50");
        indicator.classList.add("w-4", "bg-white");
      } else {
        // Inactive dots are small and semi-transparent
        indicator.classList.remove("w-4", "bg-white");
        indicator.classList.add("w-1.5", "bg-white/50");
      }
    });
  }

  // Allow clicking indicators to snap to specific images
  scrollTo(event) {
    const index = parseInt(event.currentTarget.dataset.index);
    const track = this.trackTarget;
    const clientWidth = track.clientWidth;

    track.scrollTo({
      left: index * clientWidth,
      behavior: "smooth",
    });
  }
}
